export default "__VITE_ASSET__BqGwfmtv__"